import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const technologies = [
  { name: "MySQL", icon: "/assets/mysql-logo.png" },
  { name: "PostgreSQL", icon: "/assets/postgresSql-logo.png" },
  { name: "SQL", icon: "/assets/sql-logo.png" },
  { name: "Python", icon: "/assets/python-logo.png" },
  { name: "WooCommerce", icon: "/assets/woocommerce-logo.png" },
  { name: "WordPress", icon: "/assets/wordpress-logo.png" },
  { name: "HTML5", icon: "/assets/html-logo.png" },
  { name: "Angular", icon: "/assets/angular-web-development.png" },
  { name: "Drupal", icon: "/assets/codeception-drupal-logo.png" },
  { name: "CSS3", icon: "/assets/css-logo.png" },
  { name: "Laravel", icon: "/assets/Laravel-logo.png" },
  { name: "Lambda", icon: "/assets/lambda-logo.png" },
  { name: "Joomla", icon: "/assets/joomla-logo.png" },
  { name: "Feather", icon: "/assets/feather-logo.png" },
  { name: "Blocks", icon: "/assets/blocks-logo.png" },
  { name: "Blocks 2", icon: "/assets/blocks2-logo.png" },
  { name: "aws", icon: "/assets/aws.png" },
];

const Section12 = () => {
  const settings = {
    infinite: true,
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 12,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 12 } },
      { breakpoint: 850, settings: { slidesToShow: 5 } },
    ],
  };

  return (
    <div className="container-1280 py-10 md:py-[140px] mx-auto xl:min-w-[70%] lg:min-w-[90%] w-[90%] ">
      <div className="flex flex-col items-center text-center md:items-start md:text-start">
        <h2 className="text-[26px] md:text-[30px] font-bold text-red-600">Technologies We Use</h2>
        <p className="mt-2 text-gray-600">
          Our expert team combines experience and innovation to deliver
          cutting-edge web development solutions.
        </p>
        <p className="mt-1 text-gray-600">Your Privacy Is Our Priority.</p>
      </div>

      <div className="mt-6">
        <Slider {...settings}>
          {technologies.map((tech, index) => (
            <div key={index} className="p-3">
              <div className="flex items-center justify-center w-16 h-16 p-4 bg-white rounded-lg shadow-lg">
                <img src={tech.icon} alt={tech.name} className="w-12 h-8" />
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="w-full h-px mt-10 bg-gray-800"></div>
    </div>
  );
};

export default Section12;
